// =============================================================
//  Gallery manifest — every photo mapped to a category after a
//  manual review of all images. To re-organise: change a `cat`
//  value below, or move an image id into `shopPhotos`.
//  Category ids must match siteConfig.categories.
// =============================================================

const TOTAL = 61;

// Showroom / heritage photos — shown in the "Our Shop" section,
// NOT in the product gallery grid.
//  11 = vintage old-shop photo (founders)   12 = storefront
//   1 = showroom (owner w/ necklace set)      4 = showroom (owner w/ kada)
export const shopPhotos = [
  { id: 11, src: "/assets/gallery/img-11.jpg", caption: "Where it all began — our family at the counter" },
  { id: 12, src: "/assets/gallery/img-12.jpg", caption: "Shree Abhushan Jewellers, Main Road, Bhachau" },
  { id: 1, src: "/assets/gallery/img-01.jpg", caption: "Inside our showroom" },
  { id: 4, src: "/assets/gallery/img-04.jpg", caption: "Personally curated, gloved & hallmarked" },
];

const shopIds = shopPhotos.map((s) => s.id);

// Verified per-image categories (reviewed one by one).
const overrides = {
  2: "bridal", 3: "necklaces", 5: "necklaces", 6: "bangles",
  7: "bridal", 8: "necklaces", 9: "necklaces", 10: "bridal",
  13: "bangles", 14: "earrings", 15: "watches", 16: "chains",
  17: "bangles", 18: "bangles", 19: "watches", 20: "necklaces",
  21: "bangles", 22: "bangles", 23: "necklaces", 24: "bridal",
  25: "necklaces", 26: "necklaces", 27: "necklaces", 28: "necklaces",
  29: "rings", 30: "bridal", 31: "bridal", 32: "bangles",
  33: "anklets", 34: "anklets", 35: "anklets", 36: "bridal",
  37: "anklets", 38: "rings", 39: "anklets", 40: "rings",
  41: "chains", 42: "necklaces", 43: "rings", 44: "bridal",
  45: "bangles", 46: "bridal", 47: "chains", 48: "bangles",
  49: "bangles", 50: "watches", 51: "bridal", 52: "bridal",
  53: "anklets", 54: "anklets", 55: "anklets", 56: "chains",
  57: "anklets", 58: "rings", 59: "anklets", 60: "rings",
  61: "necklaces",
};

const galleryItems = Array.from({ length: TOTAL }, (_, i) => i + 1)
  .filter((n) => !shopIds.includes(n))
  .map((n) => {
    const id = String(n).padStart(2, "0");
    return {
      id: n,
      src: `/assets/gallery/img-${id}.jpg`,
      cat: overrides[n] || "necklaces",
      alt: `Shree Abhushan Jewellers — design ${id}`,
    };
  });

// Short reels / videos for the showcase section
export const reels = [1, 2, 3, 4, 5, 6].map((n) => ({
  id: n,
  src: `/assets/videos/reel-${n}.mp4`,
}));

// Hand-picked highlight images for hero & feature blocks
//  46 = bridal choker set   8 = pearl set   44 = Royal Rajwadi (branded)
//  28 = meena set  26 = temple haram  2 = rajwadi mukut
export const featured = [46, 8, 44, 28, 26, 2].map(
  (n) => `/assets/gallery/img-${String(n).padStart(2, "0")}.jpg`
);

export default galleryItems;
